Ember.Handlebars.registerBoundHelper('br', function(value) {
    return Em.Handlebars.Utils.escapeExpression(value).replace(/\n/g, '<br>').htmlSafe()
})
